module.exports = __webpack_public_path__ + "img/light-mud-decal-09.fb72295d.png";